<template>
  <div>
    <v-card max-width="100%">
      <v-card-title>
        <h4>SIAPA - Pago V2</h4>
      </v-card-title>
      <v-card-text>
        <v-container id="scroll-target" class="overflow-y-auto" style="max-height: 900px; max-width=100%">
          <v-card max-width="800">
            <v-card-text class="d-flex flex-wrap">

              <CuentaBancariaSelect clearable @change="(p) => (this.filtroCuentaBancaria = p)" class="mx-2" />
              <MedioPagoSelect
                clearable
                @change="(p) => (this.filtroMedioPago = p)"
                class="mx-2" /> 
              <MyDatePicker fecha="" label="Fecha de pago" @fecha="(p) => (this.filtroFecha = p)" class="mx-2" />
            </v-card-text>
          </v-card>
          <!-- <v-card-actions><v-btn @click="$router.push({ path: `/reporteCheque` })" style="border: 12 12">IMPRIMIR CHEQUES</v-btn></v-card-actions> -->

          <v-data-table dense :items="pagosFiltrado" :headers="headers" :items-per-page=5 :loading="loading">
            <template v-slot:[`item.actions`]="props">
              <td>
                <v-btn small color="success" @click="detalle(props.item.id)">Detalle</v-btn>
              </td>
              <td>
                <v-btn small @click.once="notificarEmail(props.item)"
                  :disabled="!(props.item.fechaEnvioEmail == null && props.item.estado == 'Validado')"><v-icon
                    small>email</v-icon>Notificar EMAIL</v-btn>
              </td>
              <td>
                <v-btn small @click.once="notificarSms(props.item)"
                  :disabled="!(props.item.fechaEnvioSms == null && props.item.estado == 'Validado')"><v-icon
                    small>email</v-icon>Notificar SMS</v-btn>
              </td>
              <td>
                <v-btn small @click.once="imprimir(props.item.id)"><v-icon small>print</v-icon></v-btn>
              </td>
              <td v-if="1==2">
                <v-btn small disabled @click.once="formatoItau(props.item)">ITAU<v-icon small>download</v-icon></v-btn>
              </td>


              <td v-if="
                props.item.estado === 'Validado' &&
                props.item.medioPago.nombre === 'CHEQUE'
              ">
                <GenerarCheque :pagoId="props.item.id" />
              </td>
            </template>
            <template v-slot:[`item.estado`]="props">
              <v-chip :class="`${props.item.estado}  my-2 caption`">{{
                props.item.estado
              }}</v-chip>
            </template>
            <template v-slot:[`item.fechaApertura`]="props">
              {{ props.item.fechaApertura | formatDate }}
            </template>
            <template v-slot:[`item.cuentaBancaria`]="props">
              <div v-if="props.item.cuentaBancaria">
                {{
                  props.item.cuentaBancaria.banco.descripcion +
                  " - " +
                  props.item.cuentaBancaria.numero
                }}
              </div>
            </template>
          </v-data-table>

          <!-- <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Id</th>
                  <th class="text-left">Medio de Pago</th>
                  <th class="text-left">Fecha de Apertura</th>
                  <th class="text-left">Cuenta</th>
                  <th class="text-left">Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="pago in pagos" :key="pago.id">
                  <td>{{ pago.id }}</td>
                  <td>{{ pago.medioPago.nombre }}</td>
                  <td>{{ pago.fechaApertura | formatDate }}</td>
                  <td>
                    {{
                      pago.cuentaBancaria
                        ? pago.cuentaBancaria.banco.descripcion +
                          " - " +
                          pago.cuentaBancaria.numero
                        : ""
                    }}
                  </td>
                  <td>
                    <v-chip :class="`${pago.estado}  my-2 caption`">{{
                      pago.estado
                    }}</v-chip>
                  </td>
                  <td>
                    <v-btn small color="success" @click="detalle(pago.id)"
                      >Detalle</v-btn
                    >
                  </td>
                  <td>
                    <v-btn small @click.once="imprimir(pago.id)"
                      ><v-icon small>print</v-icon></v-btn
                    >
                  </td>

                  <td
                    v-if="
                      pago.estado === 'Validado' &&
                      pago.medioPago.nombre === 'CHEQUE'
                    "
                  >
                    <GenerarCheque :pagoId="pago.id" />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table> -->
        </v-container>
      </v-card-text>
      <span class="red--text">{{ errorMessage }}</span>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="$router.push('/')">Volver</v-btn>
        <v-spacer></v-spacer>
        <AgregarPago @agregarPago="agregarPago" />
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
// import axiosAuth from "@/axios-auth";
import moment from "moment";
import AgregarPago from "./AgregarPago.vue";
import GenerarCheque from "@/components/pago/GenerarCheque.vue";
import { saveAs } from "file-saver";
import CuentaBancariaSelect from "@/components/lookup/CuentaBancariaSelect";
import MedioPagoSelect from "@/components/lookup/MedioPagoSelect";
import MyDatePicker from "@/components/shared/MyDatePicker";
// import XLSX from "xlsx";
import { utils, write } from "xlsx";
import JSZip from "jszip";

export default {
  data() {
    return {
      // <th class="text-left">Id</th>
      //           <th class="text-left">Medio de Pago</th>
      //           <th class="text-left">Fecha de Apertura</th>
      //           <th class="text-left">Cuenta</th>
      //           <th class="text-left">Estado</th>

      pagos: [],
      pagosFiltrado: [],
      filtroFecha: null,
      filtroMedioPago: null,
      filtroCuentaBancaria: null,
      errorMessage: "",
      loading: false,
      headers: [
        { text: "Id", value: "id" },
        { text: "Medio de Pago", value: "medioPago.nombre" },
        { text: "Fecha de Apertura", value: "fechaApertura" },
        { text: "Cuenta", value: "cuentaBancaria" },
        { text: "Estado", value: "estado" },
        { text: "", value: "actions" },
      ],
    };
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm");
      }
    },
  },
  components: {
    AgregarPago,
    GenerarCheque,
    CuentaBancariaSelect,
    MedioPagoSelect,
    MyDatePicker,
  },
  mounted() {
    axios
      .get("/pago")
      .then((response) => {
        console.log(response);
        this.pagos = response.data.reverse();
        this.pagosFiltrado = this.pagos;
      })
      .catch((err) => {
        console.log(err);
        this.errorMessage = "Error en la consulta";
      });
  },
  methods: {
    test(a) {
      console.log(a);
    },
    detalle(id) {
      this.$router.push({ path: `/pago/${id}` });
    },
    async formatoItau(pago) {

      try {

        this.loading = true;

        const response = await axios.get(
          `/pago/detalle/${pago.id}`
        );

        const data = response.data.map((item) => ({
          "COD.DE SERVICIO": 11,
          "CTA DEBITO": pago.cuentaBancaria.numero,
          "IMPORTE DEBITO": item.monto,
          "COD DE BANCO": "FALTA TABLA",
          "TIPO DE ENVIO": 'L',
          "NRO DE CTA CREDITO": item.cuenta,
          "MONEDA DE CREDITO DE LA TRANSF": 0,
          "NRO. REFERENCIA CAMBIOS": null,
          "TIPO DE CAMBIO": null,
          "BENEFICIARIO": item.ordenPago.beneficiario.nombreCompleto,
          "TIPO DE DOC.": 1,
          "NRO. DE DOC.": item.ordenPago.beneficiario.cedula,
          "FECHA DE PAGO": moment(pago.fechaApertura).format("YYYYMMDD"),
          "NRO DE FACTURA" : null,
          "CIUDAD DEL BENEF." : null,
          "Pais Beneficiario" : null,
          "CONCEPTO MOTIVO" : null,
          "REFERENCIA EMPRESA" : null,
          "NRO DE DOC. COBRADOR" : null,
          "NOMBRE COBRADOR" : null,
          "NOTIFICACION MAIL" : "caja@apa.org.py",
          "NOTIFICACION SMS" : null,
          "MENSAJE AL BENEFICIARIO": null,
          "Banco Intermediario (SWIFT)" : null,

        }));


        const nombreArchivoBase = `PAGOID_${pago.id}_${pago.cuentaBancaria.banco.descripcion}_CTA_${pago.cuentaBancaria.numero}_FECHA_${moment(pago.fechaApertura).format("YYYYMMDD")}`;

        const zip = new JSZip();


        const wscols = [
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 40 },
          { wch: 15 },
          { wch: 15 },
        ];


        // respdetalle.data.forEach((item, index) => {
        //   const data = [
        //     {
        //       id: item.id,
        //       fechaApertura: moment(item.fechaApertura).format("DD/MM/YYYY"),
        //       cuentaBancaria: item.cuentaBancaria
        //         ? item.cuentaBancaria.banco.descripcion +
        //         " - " +
        //         item.cuentaBancaria.numero
        //         : "",
        //       estado: item.estado,
        //     },
        //     console.log(data)
        //   ];

        //   const ws = utils.json_to_sheet(data);
        //   const wb = utils.book_new();
        //   ws["!cols"] = wscols;
        //   utils.book_append_sheet(wb, ws, "Hoja1");

        //   const wbout = write(wb, { bookType: "xlsx", type: "buffer" });
        //   zip.file(`archivo_${index}.xlsx`, wbout);
        // });


        const chunkSize = 199;
        const cantidadArchivos = Math.ceil(data.length / chunkSize);
        let nuneroArchvo = 1;

        for (let i = 0; i < data.length; i += chunkSize) {

          const chunk = data.slice(i, i + chunkSize);

          const ws = utils.json_to_sheet(chunk);
          const wb = utils.book_new();
          ws["!cols"] = wscols;
          utils.book_append_sheet(wb, ws, "Hoja1");

          const wbout = write(wb, { bookType: "xlsx", type: "buffer" });
          zip.file(`${nombreArchivoBase}_${nuneroArchvo}_de_${cantidadArchivos}.xlsx`, wbout);
          nuneroArchvo++;
        }

        const contenido = await zip.generateAsync({ type: "blob" });
        saveAs(contenido, `${nombreArchivoBase}.zip`);

        this.loading = false;

      } catch (error) {

        this.loading = false;
        console.error("Error al obtener el detalle del pago:", error);

        // Opcional: lanzar un error personalizado
        //throw new Error("No se pudo obtener el detalle del pago");
        alert("Error al obtener el detalle del pago :" + error);
      }

    },
    imprimir(pagoId) {
      axios
        .post("/reports", {
          dbName: "SIAPA",
          reportName: "reporte_pago_DA.jrxml",
          base64: true,
          params: [{ nombre: "id_pago", valor: pagoId, tipo: "integer" }]
        })
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = err.response.data;
        });
    },
    agregarPago(dato) {
      console.log(dato);

      const params = {
        descripcion: dato.descripcion,
        cuentaBancaria: {
          id: dato.cuentaBancariaId,
        },
        medioPago: {
          id: dato.medioPagoId,
        },
      };

      axios
        .post('/pago/nuevo', params)
        .then((response) => {
          if (response.status !== 200) {
            window.alert("error" + response.statusText);
          }

          this.pagos.unshift(response.data);
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = err.response.data;
        });
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    filtrar() {
      this.pagosFiltrado = this.pagos;

      if (this.filtroMedioPago) {
        console.log("filtramos por medio de pago");
        this.pagosFiltrado = this.pagosFiltrado.filter(
          (e) => e.medioPago.id == this.filtroMedioPago.id
        );
      }
      if (this.filtroCuentaBancaria) {
        console.log("filtramos por cuenta bancaria", this.filtroCuentaBancaria);
        this.pagosFiltrado = this.pagosFiltrado.filter(
          (e) =>
            e.cuentaBancaria &&
            e.cuentaBancaria.id == this.filtroCuentaBancaria.id
        );
      }
      if (this.filtroFecha) {
        this.pagosFiltrado = this.pagosFiltrado.filter((e) => {
          return moment(e.fechaApertura).isSame(this.filtroFecha, 'day');
        });
      }
    },
    removeTime(date = new Date()) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },
    notificarEmail(pago) {

      axios.get('pago/notificacionEmail/' + pago.id);
      pago.fechaEnvioEmail = new Date();

    },
    notificarSms(pago) {

      axios.get('pago/notificacionSms/' + pago.id);
      pago.fechaEnvioSms = new Date();

    }
  },
  watch: {
    filtroFecha(v) {
      console.log("******", v);
      this.filtroFecha = v;
      this.filtrar();
    },
    filtroMedioPago(v) {
      this.filtroMedioPago = v;
      this.filtrar();
    },
    filtroCuentaBancaria(v) {
      this.filtroCuentaBancaria = v;
      this.filtrar();
    },
  },
};
</script>

<style scoped>
.v-chip.Abierto {
  background: lightgreen;
}

.v-chip.Validado {
  background: lightcoral;
}

.v-chip.Cerrado {
  background: lightgray;
}
</style>
